import { render, staticRenderFns } from "./setPhone.vue?vue&type=template&id=3b7e3b62&scoped=true"
import script from "./setPhone.vue?vue&type=script&lang=js"
export * from "./setPhone.vue?vue&type=script&lang=js"
import style0 from "./setPhone.vue?vue&type=style&index=0&id=3b7e3b62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7e3b62",
  null
  
)

export default component.exports